import { reduce } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoUserHabilitation from '../../user/dto/DtoUserHabilitation'
import { PANEL_JOURNAL, PANEL_REQ } from '../constants/SuperAdminConstants'
import SuperAdminReqPanel from './SuperAdminReqPanel'
import SuperAdminJournalPanel from './SuperAdminJournalPanel'
import HomeAction from '../../../../home/actions/HomeAction'
import AppStore from '../../../../store/AppStore'
import { Card, CardContent, Grid2, Tab, Tabs } from '@mui/material'

class SuperAdminPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            view: PANEL_REQ,
        }
    }

    componentDidMount() {
        AppStore.dispatch(HomeAction.setTitle([{
            title: ' (̿▀̿‿ ̿▀̿ ̿)    Super Admin    (づ｡◕‿‿◕｡)づ',
            href: 'pgsse/dashboard',
        }]))
    }

    changeState = (view) => {
        this.setState({
            view,
        })
    }

    getListOfHabilitations = () => {
        const result = reduce(
            this.props.userHabilitations,
            (a, b) => {
                (a[b.habilitation.split('_')[0]] || (a[b.habilitation.split('_')[0]] = [])).push(b)
                return a
            },
            {},
        )
        return Object.keys(result).map((o) => {
            return {
                module: o,
                values: result[o],
            }
        })
    }

    render() {
        const { view } = this.state
        const listOfHabilitations = this.getListOfHabilitations()
        return (
            <Grid2 style={{ padding: '0.75rem' }}>
                <Tabs
                    value={view}
                    onChange={(e, newValue) => this.setState({ view: newValue })}
                    variant='fullWidth'
                >
                    <Tab value={PANEL_REQ} label={i18n.request}/>
                    <Tab value={PANEL_JOURNAL} label={i18n.journal}/>
                </Tabs>
                <Card sx={{ borderRadius: '0 0 10px 10px' }}>
                    <CardContent>
                        { view === PANEL_REQ && (<SuperAdminReqPanel listOfHabilitations={listOfHabilitations} />)}
                        { view === PANEL_JOURNAL && (<SuperAdminJournalPanel listOfHabilitations={listOfHabilitations} />)}
                    </CardContent>
                </Card>
            </Grid2>
        )
    }

    componentDidUpdate() {
        $('ul.tabs').tabs()
    }
}

SuperAdminPanel.propTypes = {
    userHabilitations: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserHabilitation)),
}

const mapStateToProps = (store) => {
    return {
        userHabilitations: store.UserReducer.userHabilitations,
    }
}
export default connect(mapStateToProps)(SuperAdminPanel)

